import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import defaultAvatar from '../assets/default-avatar.png';
import './Header.css';

const Header = ({ onLogout }) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleProfileClick = () => {
    if (user?.id) {
      navigate(`/users/${user.id}/edit`);
    }
  };

  return (
    <header className="page-header">
      <div className="header-row">
        {/* Logo Column - col-4 on mobile, col-8 on desktop */}
        <div className="header-col header-col-logo">
          <a href="/dashboard" className="logo-link">
            <img src="/images/logo-new.png" alt="MYGLOBE" className="logo-img" />
          </a>
        </div>

        {/* Logout Column - col-2 on mobile, col-1 on desktop */}
        <div className="header-col header-col-logout">
          <button onClick={onLogout} title="Logout" className="logout-btn">
            <img src="/images/logout-navy.png" alt="Logout" className="logout-icon" />
          </button>
        </div>

        {/* User Profile Column - col-6 on mobile, col-3 on desktop */}
        <div className="header-col header-col-user">
          <div className="account-box" onClick={handleProfileClick}>
            <img
              src={defaultAvatar}
              alt="avatar"
              className="account-avatar"
            />
            <p className="user-name">{user?.first_name} {user?.last_name}</p>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header; 